import React from 'react';
import { put, call, takeLatest, all } from 'redux-saga/effects';
import * as types from './constants';
import * as actions from './actions';
import { DEFAULT_SORT } from 'static/Constants';

import {
  getMemberOverviewDocument,
  getMemberContactHistory,
  getMemberShortDetail,
  getMemberDocument,
  deleteMemberDocument,
} from 'services/members';
import * as services from 'services/members';
import * as servicesGrid from 'services/grid';
import moment from 'moment';
import IconRenderer from '../components/tabs/crm/activity/IconRenderer';
import {
  MemberBillingIconRenderer,
  MemberContactIconRenderer,
  MemberLocationIconRenderer,
} from 'common/components/icon-renderer/IconRenderer';
import * as filterService from './filterService';
import { formatMDYWithParam } from 'utils/formatDate';

// BP 08/31/2020: TODO need to review more carefully
export function* memberContactHistorySaga(payload) {
  try {
    const response = yield call(getMemberContactHistory, { ...payload });
    yield put(actions.getMemberContactHistorySuccess(response));
  } catch (error) {
    yield put({ type: types.GET_MEMBER_CONTACT_HISTORY_ERROR, error });
  }
}

export function* fetchMemberDocument(payload) {
  try {
    const props = payload.payload;
    const response = yield call(getMemberOverviewDocument, {
      MemberId: props.memberId,
      PageIndex: props.currentPage,
      PageSize: props.pageSize,
    });
    yield put({
      type: types.FETCH_MEMBER_OVERVIEW_DOCUMENT_SUCCESS,
      data: response,
    });
  } catch (error) {
    yield put({
      type: types.FETCH_MEMBER_OVERVIEW_DOCUMENT_ERROR,
      error,
    });
  }
}

// get contacts by memberId
export function* getContactMemberSaga(payload) {
  try {
    const response = yield call(services.getMemberContact, {
      ...payload.params,
      memberId: Number(payload.params.memberId),
    });
    yield put(actions.getMemberContactsSuccess(response.data));
  } catch (error) {
    yield put(actions.getMemberContactsError(error));
  }
}

export function* getMemberBrandsSaga(payload) {
  try {
    const response = yield call(services.getMemberOverviewBrands, {
      ...payload.params,
      memberId: Number(payload.params.memberId),
      sort: DEFAULT_SORT,
    });
    const { isSuccess, data, message } = response;
    if (isSuccess) {
      yield put(actions.getMemberBrandsSuccess(data));
    } else {
      yield put(actions.getMemberBrandsError(message));
    }
  } catch (error) {
    yield put(actions.getMemberBrandsError(error));
  }
}

export function* getMemberInformationSheetSaga(payload) {
  try {
    const response = yield call(services.getMemberInformationSheetGrid, {
      ...payload.params,
      memberId: Number(payload.params.memberId),
      sort: DEFAULT_SORT,
    });
    const { isSuccess, data, message } = response;
    if (isSuccess) {
      yield put(actions.getMemberInformationSheetSuccess(data));
    } else {
      yield put(actions.getMemberInformationSheetError(message));
    }
  } catch (error) {
    yield put(actions.getMemberInformationSheetError(error));
  }
}

// Date Formatter
function dateFormatter(params) {
  return moment(params.value).format('MM/DD/YYYY');
}

// GET MEMBER BILLING GRID
const renderIconBilling = (params) => {
  return <MemberBillingIconRenderer item={params} />;
};

export function* getColumnDocumentDetailList(payload) {
  try {
    const { response } = yield call(
      servicesGrid.gridColumnInfo,
      payload.gridName
    );

    const checkboxColumn = [
      {
        field: '',
        checkboxSelection: true,
        filter: false,
        suppressHeaderMenuButton: true,
        resizable: true,
      },
    ];

    let result = [];

    if (response && response.columns && response.columns.length > 0) {
      response.columns.forEach((val, index) => {
        if (
          val.fieldNameCamelCase === 'banByMemberName' ||
          val.fieldNameCamelCase === 'bannedMemberName'
        ) {
          result.push({ ...val, resizable: true, width: 240 });
        } else if (val.fieldNameCamelCase === 'banByUserId') {
          result.push({
            ...val,
            resizable: true,
            width: 100,
            headerName: 'Owner',
          });
        }
      });
    }
    yield put(
      actions.documentDetailColumnInfoSuccess([...checkboxColumn, ...result])
    );
  } catch (error) {
    yield put(actions.documentDetailColumnInfoError(error));
  }
}

// GET MEMBER CONTACT GRID
const renderIconContact = (params) => {
  return <MemberContactIconRenderer item={params} />;
};

const renderCityState = (params) => {
  if (params?.data?.city || params?.data?.state)
    return (
      <>
        {params.data.city}, {params.data.state}
      </>
    );
  else return <></>;
};

// GET MEMBER LOCATION GRID
const renderIconLocation = (params) => {
  return <MemberLocationIconRenderer item={params} />;
};

// GET MEMBER ACTIVITY LOG GRID
const renderIcon = (params) => {
  return <IconRenderer item={params} />;
};

// GET MEMBER CONTACT HISTORY

export function* getMemberShortDetailPreview(payload) {
  try {
    const response = yield call(getMemberShortDetail, {
      Id: payload.id,
    });
    const { isSuccess, data, message } = response;
    if (isSuccess) {
      yield put(actions.getMemberShortDetailPreviewSuccess(data));
    } else {
      yield put(actions.getMemberShortDetailPreviewError(message));
    }
  } catch (error) {
    yield put(actions.getMemberShortDetailPreviewError(error));
  }
}

export function* getMemberDocumentDetail(payload) {
  try {
    const { dataParams } = payload;
    const response = yield call(getMemberDocument, {
      pageIndex: dataParams?.pageIndex,
      pageSize: dataParams?.pageSize,
      memberId: dataParams?.memberId,
    });
    const { data, isSuccess } = response;
    if (isSuccess) {
      yield put(actions.getDocumentDetailSuccess(data));
    } else {
      yield put(actions.getDocumentDetailError('error'));
    }
  } catch (error) {
    yield put(actions.getDocumentDetailError(error));
  }
}

export function* deleteMemberDocumentDetail(payload) {
  try {
    const { dataParams } = payload;
    const response = yield call(deleteMemberDocument, {
      ids: dataParams?.idList,
      isRemovedFromShowcase: dataParams?.isRemove,
      memberId: dataParams?.memberId,
      forMemberDocument: dataParams?.forMemberDocument,
    });
    const { data, isSuccess } = response;
    if (isSuccess) {
      yield put(
        actions.getDocumentDetail({
          memberId: dataParams.memberId,
          pageIndex: dataParams.currentPage,
          pageSize: dataParams.pageSize,
        })
      );
    } else {
      yield put(actions.deleteDocumentDetailError('error'));
    }
  } catch (error) {
    yield put(actions.deleteDocumentDetailError(error));
  }
}

function* watchAll() {
  yield all([
    takeLatest(types.GET_MEMBER_CONTACT_HISTORY, memberContactHistorySaga),
    takeLatest(
      types.GET_MEMBER_SHORT_DETAIL_PREVIEW,
      getMemberShortDetailPreview
    ),
    takeLatest(types.GET_MEMBER_CONTACTS, getContactMemberSaga),
    takeLatest(types.GET_MEMBER_OVERVIEW_BRANDS, getMemberBrandsSaga),
    takeLatest(
      types.GET_MEMBER_INFORMATION_SHEET,
      getMemberInformationSheetSaga
    ),
    takeLatest(types.DOCUMENT_DETAIL_COLUMN_INFO, getColumnDocumentDetailList),
    takeLatest(types.GET_DOCUMENT_DETAIL, getMemberDocumentDetail),
    takeLatest(types.DELETE_DOCUMENT_DETAIL, deleteMemberDocumentDetail),
  ]);
}

export default watchAll;
